/**
 * 分享构建专用路由：仅 manifest 中登记的已完成页面。
 * 由 PREVIEW_SHARE_BUILD=1 构建时通过 webpack alias 替换 router/index.js。
 */
import { createRouter, createWebHistory } from 'vue-router';
import { COMPLETED_PAGES } from '../completed-pages/manifest.js';
import { foundationBusinessRoutes } from './foundationBusinessRoutes.js';
import { SHARE_COMPANION_ROUTES } from '../completed-pages/shareCompanionRoutes.js';

const completedPageRoutes = COMPLETED_PAGES.map((p) => ({
  path: `/completed-pages/p/${p.id}`,
  name: p.routeName ?? `CompletedPage__${p.id.replace(/[^a-zA-Z0-9_]/g, '_')}`,
  component: p.component,
}));

const routes = [
  {
    path: '/',
    redirect: '/completed-pages',
  },
  {
    path: '/completed-pages',
    name: 'ShareCompletedHub',
    component: () => import('../views/ShareCompletedHub.vue'),
  },
  ...completedPageRoutes,
  ...foundationBusinessRoutes,
  ...SHARE_COMPANION_ROUTES,
  {
    path: '/completed-pages/p/dt30-app-mini-functions',
    redirect: '/completed-pages/p/dt30-construction-log',
  },
  {
    path: '/design-test/dt-44-infra-pour-order-app',
    redirect: '/completed-pages/p/dt44-infra-pour-order-app',
  },
  {
    path: '/design-test/dt-52-mix-notice-app',
    redirect: '/completed-pages/p/dt52-mix-notice-app',
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'ShareNotFound',
    component: () => import('../views/ShareNotFound.vue'),
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
